import { AwaitContainer } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHasPermission } from '@/entities/profile';
import { useThemeConfig } from '@/entities/settings';
import { PageContainer } from '@/shared/ui';
import { InterruptionSettingsCard } from './ui/InterruptionSettingsCard';
import { TimeSettingsCard } from './ui/TimeSettingsCard';

/**
 * Раздел «Общее»: настройки, действующие на всю систему сразу и одинаково для всех пользователей.
 * Страница только размещает карточки настроек — данные каждой держит сама карточка.
 * Изменение доступно только с правом администрирования общих настроек.
 */
export const GeneralSettingsPage: FC = () => {
  const { t } = useTranslation('generalSettings');
  const { isLoading } = useThemeConfig();
  const canAdmin = useHasPermission('ADMIN_GENERAL_SETTINGS');

  return (
    <PageContainer className="flex flex-col gap-6">
      <h1 className="text-2xl font-bold">{t('pageTitle')}</h1>
      <AwaitContainer className="flex flex-col gap-6" isLoading={isLoading}>
        <TimeSettingsCard canEdit={canAdmin} />
        <InterruptionSettingsCard canEdit={canAdmin} />
      </AwaitContainer>
    </PageContainer>
  );
};
